import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { InteractiveCasesService, InteractiveCase } from '../../services/interactive-cases.service';

@Component({
  selector: 'app-case-explanation',
  templateUrl: './case-explanation.component.html',
  styleUrls: ['./case-explanation.component.scss']
})
export class CaseExplanationComponent implements OnInit, OnChanges {
  @Input() caseId: number | null = null;
  @Input() index: number | null = null;
  activeTab: string = 'approach';
  loading: boolean = false;
  error: string | null = null;
  caseData: InteractiveCase | null = null;
  
  constructor(private interactiveCasesService: InteractiveCasesService) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.caseId) {
      this.loadCaseExplanation(this.caseId);
    }
  }

  loadCaseExplanation(caseId: number): void {
    this.loading = true;
    this.error = null;
    
    // Load case details with explanation data
    this.interactiveCasesService.getInteractiveCases().subscribe(
      (cases) => {
        this.caseData = cases.find(c => c.id === caseId) || null;
        this.loading = false;
        
        if (!this.caseData) {
          this.error = 'Case not found.';
        }
      },
      (error) => {
        this.error = 'Failed to load case data.';
        this.loading = false;
        console.error(`Error loading case ${caseId}`, error);
      }
    );
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  isActiveTab(tab: string): boolean {
    return this.activeTab === tab;
  }

  // Helper methods to get HTML content for each tab
  getApproachContent(): string {
    return this.caseData?.explanation || '<p>No approach information available for this case.</p>';
  }

  getScoringContent(): string {
    return this.caseData?.scoring || '<p>No scoring information available for this case.</p>';
  }

  getClockManagementContent(): string {
    return this.caseData?.clock_management || '<p>No clock management information available for this case.</p>';
  }
}
